angular.module('impactx.greetingcard').controller('BasketItemGreetingCardCtrl', [
    '$scope',
    'dataGen',
    '$mdDialog',
    'TranslationService',
    '$config',
    'ToastService',
    'bkiId',
    '$window',
    'NewWindowService',
    BasketItemGreetingCardCtrl
]);

function BasketItemGreetingCardCtrl($scope, dataGen, $mdDialog, TranslationService, $config, ToastService, bkiId, $window, NewWindowService) {
    $scope.newWindow = {};
    var self = this;
    $scope.wizardIndex = 0;
    var firstTemplateCall = true;
    dataGen.getData($scope, {bkiId: bkiId}, "/basket/greetingcard/item/view").then(function () {
        $scope.trns.save = TranslationService.get("save");
        $scope.trns.delete = TranslationService.get("delete");
        $scope.trns.abort = TranslationService.get("abort");
        $scope.trns.required = TranslationService.get('required');
        $scope.trns.noSelectedItemMessage = TranslationService.get('noSelectedItemMessage');
        $scope.trns.forward = TranslationService.get('forward');
        $scope.trns.back = TranslationService.get('back');
        $scope.adjustDates();
    });

    this.saveGreetingCard = function () {
        if ($scope.wizardIndex === 0 && $scope.data.deliverTo.value) {
            $scope.wizardIndex++;
            dataGen.postAsForm({}, {bkiId: bkiId, gct: $scope.data}, "/basket/greetingcard/item/address").then(function (data) {
                $scope.data.deliverToAddress = data.data;
            });
        }
        else {
            dataGen.postAsForm($scope, {bkiId: bkiId, gct: $scope.data}, "/basket/greetingcard/item/save").then(function () {
                $mdDialog.hide();
                ToastService.openStandardToast(TranslationService.get("saveSuccess"));
            });
        }
    };

    this.deleteGreetingCard = function () {
        dataGen.postAsForm($scope, {bkiId: bkiId}, "/basket/greetingcard/item/delete").then(function () {
            $mdDialog.hide();
            ToastService.openStandardToast(TranslationService.get("deleteSuccess"));
        });
    };

    this.cancel = function () {
        $mdDialog.cancel();
    };

    this.updateGCTData = function (selected) {
        var tempScope = {};
        if (!$scope.data.gctId || !firstTemplateCall) {
            if (selected) {
                dataGen.getData(tempScope, {gctId: selected.id}, "/basket/greetingcard/template/data").then(function () {
                    $scope.trns.GCTExplanation = tempScope.trns.GCTExplanation;
                    $scope.data.subject = tempScope.data.subject;
                    $scope.data.placeHolder = tempScope.data.placeHolder;
                    $scope.data.text = tempScope.data.text;
                    $scope.data.gctId = tempScope.data.gctId;
                    $scope.data.isPersonal = tempScope.data.isPersonal;
                });
            }
            else {
                $scope.trns.GCTExplanation = undefined;
                $scope.data.subject = undefined;
                $scope.data.placeHolder = undefined;
                $scope.data.text = undefined;
                $scope.data.isPersonal.readOnly = false;
                $scope.data.gctId = 0;
            }
        }
        firstTemplateCall = false;
    };

    this.back = function() {
        $scope.wizardIndex = 0;
    };

    this.printGreetingCard = function () {
        self.openNewWindow();
        dataGen.post($scope, {bkiId: bkiId, gct: $scope.data}, '/basket/greetingcard/item/preview', null, {responseType: 'arraybuffer'}).then(function (data) {
                var fileName = getFileNameFromResponseHeaders(dataGen.lastRequestHeaders());
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(new Blob([data], {type: 'application/pdf'}), fileName);
                }
                else {
                    var file = new Blob([data], {type: 'application/pdf'});
                    $scope.newWindow.location = URL.createObjectURL(file);
                    $scope.newWindow.document.title = fileName;
                }
            }
        );
    };

    function getFileNameFromResponseHeaders(responseHeaders) {
        var fileName = "";
        if (responseHeaders) {
            var contentDisposition = responseHeaders['content-disposition'];
            if (contentDisposition) {
                fileName = contentDisposition.split(';')[1].trim().split('=')[1];
            }
        }

        return fileName;
    }

    this.openNewWindow = function () {
        if (!window.navigator.msSaveOrOpenBlob) {
            $scope.newWindow = NewWindowService.openNewWindow('')
        }
    };

    $scope.tinymceOptions = $config.tinymceOptions;

    $scope.adjustDates = function () {
        $scope.data.deliveryDate.minDate = new Date($scope.data.deliveryDate.minDate);
    };
}
